import { useEffect, useState } from "react";
import format from "date-fns/format";

import { Avatar, ListItem } from "@mui/material";
// import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
// import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import API from "../../API";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { handleChatRoomData } from "../../Redux/Reducer";

// const StyledListItem = styled(ListItemButton)<any>(({ theme }) => ({
//     "&.active": {
//         backgroundColor: theme.palette.background.default
//     },
//     borderBottom: 1
//     // padding: 8
//     // paddingLeft: 4,
//     // paddingRight: 4,
//     // paddingTop: 2,
//     // paddingBottom: 2
// }));

type ChatListItemProps = {
    item: any;
};

/**
 * The chat list item.
 */
function ChatListItem(props: ChatListItemProps) {
    const dispatch = useAppDispatch();
    const parameterValues = Object.fromEntries(new URLSearchParams(window.location.search).entries());
    const { user } = useAppSelector((state) => state);
    const { item } = props;
    const [selected, setSelected] = useState(false);
    // eslint-disable-next-line no-console
    const handleSelected = async (e?: any) => {
        const chatResponse: any = await API.Chat.getChatByDealershipId({
            DealerShip: e?.DealerShip || parameterValues?.DealerID,
            Inventory_ID: e?.Inventory_ID || parameterValues?.inventryid
        });
        if (user?.RoleId === 1 || user?.RoleId === 2) {
            // if (e?.Sender_UserId) {
            dispatch(handleChatRoomData(chatResponse?.data?.data));
            // } else {
            //     dispatch(
            //         handleChatRoomData(chatResponse?.data?.data?.filter((entry: any) => entry?.Sender_UserId === Number(parameterValues?.chatUser)))
            //     );
            // }
        } else if (item?.First_Name) {
            let combainedValue: any;
            if (chatResponse?.data?.data?.length > 0) {
                combainedValue = chatResponse?.data?.data?.map((value: any) => ({
                    ...value,
                    First_Name: item?.First_Name,
                    Last_Name: item?.Last_Name
                }));
            } else {
                combainedValue = [
                    {
                        First_Name: item?.First_Name,
                        Last_Name: item?.Last_Name
                    }
                ];
            }
            dispatch(handleChatRoomData(combainedValue));
            setSelected(true);
        } else {
            dispatch(handleChatRoomData(chatResponse?.data?.data || []));
        }
        // setChats(chatResponse?.data?.data);
    };
    useEffect(() => {
        handleSelected();
    }, []);
    return (
        <ListItem className="px-32 py-16" selected={selected} sx={{ cursor: "pointer" }}>
            <Avatar sx={{ bgcolor: "#ececec", height: 40, width: 40 }}>
                <Typography fontWeight={700}>{item?.UserName?.split("")?.[0] ?? item?.First_Name?.split("")?.[0]}</Typography>
            </Avatar>
            <ListItemText
                classes={{
                    root: "min-w-px px-16",
                    primary: "font-medium text-14",
                    secondary: "truncate"
                }}
                primary={item.UserName ?? `${item.First_Name} ${item.Last_Name}`}
                secondary={
                    <>
                        <Typography component="span" variant="body2" color="text.secondary" display="block">
                            {item?.Name}
                        </Typography>
                        <Typography component="span" variant="body2" color="text.primary" display="block">
                            {`${parameterValues?.year || item?.Year || item?.Inventory?.Year || ""} ${
                                parameterValues?.make || item?.Make || item?.Inventory?.Make || ""
                            } ${parameterValues?.model || item?.Model || item?.Inventory?.Model || ""}`}
                        </Typography>
                    </>
                }
                onClick={() => {
                    setSelected(!selected);
                    handleSelected(item);
                }}
            />
            {item.Sender_UserId && (
                <div className="flex flex-col justify-center items-end">
                    {item?.CreatedDate && (
                        <Typography className="whitespace-nowrap mb-8 font-medium text-12" color="text.secondary">
                            {format(new Date(item.CreatedDate), "PP")}
                        </Typography>
                    )}
                    {/* <div className="items-center">
                        {item?.muted && <IconButton>Volume</IconButton>}
                        {Boolean(item.IsRead) && (
                            <Box
                                sx={{
                                    backgroundColor: "secondary.main",
                                    color: "secondary.contrastText"
                                }}
                                className="flex items-center justify-center min-w-20 h-20 rounded-full font-medium text-10 text-center"
                            >
                                {item.IsRead}
                            </Box>
                        )}
                    </div> */}
                </div>
            )}
        </ListItem>
    );
}

export default ChatListItem;
